import { CommonModal } from 'components/common';
import React, { useEffect, useState } from 'react'
import { IoMdRadioButtonOn } from 'react-icons/io';
import '../../components/UpdateModal/updateModal.css'
import { CommonDatePicker, CommonInput } from 'components';
import { changeVehicleStatusData, updateVehiclePlanningStatus } from '_services/accountsServices/vehicleServices';
import toast from 'react-hot-toast';
import StorageService from 'utils/StorageServices';

const list = [
    { name: 'On Time' },
    { name: 'Vehicle Running Late By' },
    { name: 'At Party Point and Unload By' },
    { name: 'Other' },
    { name: 'Running Before' }
];

const hoursArray = [
    { name: '1 Hours' },
    { name: '3 Hours' },
    { name: '6 Hours' },
    { name: '12 Hours' },
    { name: '24 Hours' }
];

const maintenanceList = [
    { name: 'Update Maintenance Time' },
];

const getHours = (name) => {
    if (!name) return 0;
    const match = name.match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
};

const toDate = (val) => {
    if (!val) return new Date();
    if (val instanceof Date) return val;
    return new Date(val);
};

const UpdateMaintenanceStatus = (props) => {
    const { isOpen, closeModal = () => { }, callListApi = () => { } } = props;

    const [loading, setLoading] = useState(false);
    const [formValue, setFormValue] = useState({
        company_id: StorageService.getCompanyId(),
        vehicle_id: '',
        updated_available_date: new Date(),
        status_type: { name: 'Update Maintenance Time' },
        selection_type: {},
        remarks: ""
    });

    useEffect(() => {
        const selectionName = formValue?.selection_type?.name;
        const statusName = formValue?.status_type?.name;

        const baseDate = formValue?.updated_available_date; // toDate(isOpen?.availability?.date);

        if (!selectionName) {
            setFormValue((s) => ({ ...s, updated_available_date: baseDate }));
            return;
        }

        const hours = getHours(selectionName);
        if (hours === 0) return;

        const ms = hours * 60 * 60 * 1000;

        const newDate = statusName === 'Running Before' ? new Date(baseDate.getTime() - ms) : new Date(baseDate.getTime() + ms);

        setFormValue((s) => ({ ...s, updated_available_date: newDate }));

    }, [formValue?.selection_type?.name, formValue?.status_type?.name]);

    useEffect(() => {
        if (!isOpen) return;

        if (isOpen?.edit === true) {
            setFormValue((s) => ({
                ...s,
                vehicle_id: isOpen?.vehicle_id,
                status_type: { name: 'Update Maintenance Time' },
                selection_type: {},
                updated_available_date: new Date(),
                remarks: ""
            }));
        } else {
            // const baseDate = toDate(isOpen?.availability?.date);

            setFormValue((s) => ({
                ...s,
                vehicle_id: isOpen?.vehicle_id,
                status_type: { name: 'Update Maintenance Time' },
                selection_type: {},
                updated_available_date: new Date(),
                remarks: ""
            }));
        }
    }, [isOpen]);


    const handleStatusClick = (item) => {
        setFormValue((s) => ({
            ...s,
            status_type: item,
            selection_type: {},                              // clear hours selection
            updated_available_date: toDate(isOpen?.availability?.date), // reset to base
            remarks: ''
        }));
    };

    const handleSelectionClick = (item) => {
        setFormValue((s) => ({ ...s, selection_type: item }));
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            let obj = {
                ...formValue,
                status_type: formValue?.status_type?.name || "",
                selection_type: formValue?.selection_type?.name || "",
                company_id: StorageService.getCompanyId(),
                vehicle_status: 3,
            };
            const res = await updateVehiclePlanningStatus(obj);
            if (res?.responseCode === 200) {
                toast.success(`Status Updated Successfully`);
            } else {
                toast.error(res?.responseMessage);
            }
            callListApi();
            closeModal();
            setFormValue({});
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleProps = {
        ...props,
        onSubmit: handleSubmit,
        submitTitle: loading ? "Loading..." : "Update Status",
        isLoadding: loading,
    };

    return (
        <CommonModal {...handleProps}>
            <ul className="__onTripUl">
                {maintenanceList.map((item, index) => (
                    <li
                        key={`${item?.name}-abc-${index}`}
                        className={`__onTripLi ${formValue?.status_type?.name === item?.name ? "active" : ""}`}
                        onClick={() => handleStatusClick(item)}
                    >
                        <div className="__onTripFlx">
                            <IoMdRadioButtonOn />
                            <span>{item?.name}</span>
                        </div>

                        {formValue?.status_type?.name === item?.name && (
                            <div className="__extraDiv" onClick={(e) => e.stopPropagation()}>
                                {formValue?.status_type?.name != 'Running Before' ?
                                    <CommonDatePicker
                                        name="invoice_date"
                                        label="Update Vehicle Availablity"
                                        id={`trip-date-${index}`}
                                        minDate={toDate(isOpen?.availability?.date)}
                                        startDate={formValue?.updated_available_date}
                                        setStartDate={(data) =>
                                            setFormValue((s) => ({ ...s, updated_available_date: data }))
                                        }
                                    /> :
                                    <CommonDatePicker
                                        name="invoice_date"
                                        label="Update Vehicle Availablity"
                                        id={`trip-date-${index}`}
                                        maxDate={toDate(isOpen?.availability?.date)}
                                        startDate={formValue?.updated_available_date}
                                        setStartDate={(data) =>
                                            setFormValue((s) => ({ ...s, updated_available_date: data }))
                                        }
                                    />
                                }

                                <div className='__hrsMain_dv'>
                                    {hoursArray.map((el, iddx) => (
                                        <button
                                            key={`${el?.name}-${iddx}`}
                                            className={`__hrsM_btn ${formValue?.selection_type?.name === el?.name ? "active" : ""}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleSelectionClick(el);
                                            }}
                                        >
                                            {el?.name}
                                        </button>
                                    ))}
                                </div>

                                <CommonInput
                                    placeholder='Notes'
                                    label='Notes'
                                    value={formValue?.remarks}
                                    onChange={(e) =>
                                        setFormValue((s) => ({ ...s, remarks: e.target.value }))
                                    }
                                />
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </CommonModal>
    );
};

export default UpdateMaintenanceStatus;